/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { defaultPaths } from './default-paths';

const modelPaths = (base: string) => ({
  ...defaultPaths(base),
  completion: { detail: (id: string) => `${base}/completion/${id}` },
  chat: { detail: (id: string) => `${base}/chat/${id}` },
  imageGeneration: { detail: (id: string) => `${base}/image-generation/${id}` },
});

const serverlessEndpointsPaths = (base: string) => ({
  ...defaultPaths(base),
  landing: `${base}/landing`,
  model: modelPaths(`${base}/model`),
});

export default serverlessEndpointsPaths;
